import React from 'react';
import { createPortal } from 'react-dom';
import PropTypes from 'prop-types';
import cx from 'classnames';
import style from './fullScreenPortal.module.css';

export const FullScreenPortal = ({ children, nonePointerEvents }) => {
  const el = document.getElementById('full-screen-portal');
  return createPortal(
    <div className={cx(style.root, { [style.nonePointerEvents]: nonePointerEvents })}>
      {children}
    </div>,
    el,
  );
};

FullScreenPortal.propTypes = {
  children: PropTypes.node.isRequired,
  nonePointerEvents: PropTypes.bool,
};
